const actions = {
  SET_STATE : 'cache/SET_STATE',
  SET_SEARCH: 'cache/SET_SEARCH',
}

export default actions
